import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchWebhookSettings, updateWebhookSettings, type WebhookSettings } from '../api-client';

const KEY = ['launcher', 'webhook-settings'] as const;

export function useWebhookSettings() {
  const { apiFetch } = useApi();
  const query = useQuery<WebhookSettings>({
    queryKey: KEY,
    queryFn: () => fetchWebhookSettings(apiFetch),
    staleTime: Infinity,
  });
  return {
    settings: query.data ?? { launch_webhook_url: null, reenrich_webhook_url: null, add_member_webhook_url: null, campaign_view_webhook_url: null },
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}

export function useUpdateWebhookSettings() {
  const { apiFetch } = useApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settings: Partial<WebhookSettings>) => updateWebhookSettings(apiFetch, settings),
    onSuccess: (data) => {
      queryClient.setQueryData(KEY, data);
    },
  });
}
